import { useMemo } from "react";
import usePermissions from "hooks/usePermissions";
const useAuthorizedColumnSchemas = (columnSchemas) => {
  const { isPermitted, isAnyPermitted } = usePermissions();
  return useMemo(
    () => columnSchemas.filter(({ permissions, anyPermissions, hidden }) => {
      if (hidden) {
        return false;
      }
      if (permissions == null ? void 0 : permissions.length) {
        return anyPermissions ? isAnyPermitted(permissions) : isPermitted(permissions);
      }
      return true;
    }),
    [columnSchemas, isPermitted, isAnyPermitted]
  );
};
export default useAuthorizedColumnSchemas;
